'use client'

import React, { useEffect } from 'react'
import { ArtistTalk } from './ArtistTalk'
import { FooterDescription } from './FooterDescription'
import { PurchaseButtonSection } from './PurchaseButtonSection'
import { ArtistMotionSection } from './ArtistMotionSection'
import { homeActionLog } from '@/modules/action-log/home'
import { HosooHeader } from '@/components/ui/header/HosooHeader'
import { memberService } from '@/modules/member'

export const HomePage = () => {
  useEffect(() => {
    homeActionLog.inital()
    memberService.mainInit()
  }, [])

  return (
    <div className="flex flex-col relative bg-[#4D4B66] min-h-[100%] max-w-[100%]">
      <HosooHeader />
      <div className="bg-[linear-gradient(260deg,#FE468A_40.53%,#CB343B_92.63%)] h-[40px] flex items-center justify-center gap-[8px]">
        <p className="text-white text-body3_strong text-center">{'[ 판매가 종료되었습니다 ]'}</p>
      </div>
      <div>
        <div
          className="bg-cover bg-no-repeat bg-center bg-gray-300 h-[600px] flex flex-col relative"
          style={{ backgroundImage: 'url(/img/home/background.jpg)' }}
        >
          <div className="w-[100%] flex justify-center items-center pt-[16px]">
            <ArtistTalk />
          </div>
          <ArtistMotionSection />
          <PurchaseButtonSection />
        </div>
        <FooterDescription />
      </div>
    </div>
  )
}
